import styled, { css } from 'styled-components';

const Separator = styled.div`
  width: 100%;
  height: 1.1px;
  background: var(--grey300);
  ${({ fullWidth }) =>
    !!fullWidth &&
    css`
      width: calc(100% + 32px);
      margin-left: calc(-32px / 2);
    `};
  ${({ vertical }) =>
    !!vertical &&
    css`
      height: 100%;
      width: 1.1px;
    `};
`;
export default Separator;
